export const popoverAnchorOrigin = { vertical: 'bottom', horizontal: 'left' };
export const popoverTransformOrigin = { vertical: 'top', horizontal: 'left' };

export const groupButtonSx = {
  height: '32px',
  padding: '4px 12px',
  fontSize: '1.2rem',
  fontWeight: 400,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  borderRadius: '8px',
  border: '1px solid',
  borderColor: ({ palette }) => palette.primary.main,
  color: ({ palette }) => palette.primary.main,
  '&:hover': {
    borderColor: ({ palette }) => palette.primary.main,
    backgroundColor: ({ palette }) => palette.primary.soft,
  },
};

const popoverPaperSx = {
  borderRadius: '8px',
};

export const popoverSlotProps = {
  paper: { sx: popoverPaperSx },
};

export const popoverContentSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '8px',
  minWidth: '180px',
};
